/*  imported from AnnouncementPage.module.scss  */

@import '~@tdcerhverv/parrotfish/dist/colors-design-token.scss';

.AnnouncementPage-module__announcement__page___30Wk0 {
  padding: 2rem;
  text-align: center;
  font-weight: 100;
  color: map-get($theme, 'black');
}

.AnnouncementPage-module__announcement__page__link___37a6y {
  color: inherit;
  text-decoration: underline;
}

.AnnouncementPage-module__announcement__page__icon___VKrSh {
  margin-bottom: 1rem;
  fill: map-get($theme, 'grey-darkest');
}

.AnnouncementPage-module__announcement__page__icon__info___2YRw5 {
  fill: map-get($theme, 'info');
}

.AnnouncementPage-module__announcement__page__icon__positive___1e4Me {
  fill: map-get($theme, 'success');
}

.AnnouncementPage-module__announcement__page__icon__negative___1Kdml {
  fill: map-get($theme, 'error');
}

.AnnouncementPage-module__announcement__page__icon__warning___3iupX {
  fill: map-get($theme, 'warning');
}
